export default __webpack_public_path__ + "static/background-4557566c879b0c26b2bd6ecfd2af2dca.png";